import ForgotPassword from "../components/public/ForgotPassword/ForgotPassword";
import ResetPassword from "../components/public/ForgotPassword/ResetPassword";
import Home from "../components/public/Home/Home";
import Privacy from "../components/public/Privacy";
import ProceedSubscription from "../components/public/ProceedSubscription";
import Signup from "../components/public/Signup";
import CounterPartySignUp from "../components/public/CounterPartySignUp";
import SignUpSuccess from "../components/public/SignUpSuccess";
import Subscription from "../components/public/Subscription";
import TermsAndConditions from "../components/public/TermsAndConditions";
import UserLogin from "../components/public/UserLogin";
import VerificationSuccess from "../components/public/VerificationSuccess";
import TrucklineSignup from "../components/public/TrucklineSignup";
import CounterPartyBilling from '../components/private/Billing/CounterPartyBilling';
export default {
  Home: {
    component: Home,
    path: "/"
  },
  // Contact: {
  //     component: Contact,
  //     path: '/contact'
  // },
  UserLogin: {
    component: UserLogin,
    path: "/login"
  },
  Signup: {
    component: Signup,
    path: "/signup"
  },
  CounterPartySignUp: {
    component: CounterPartySignUp,
    path: "/CounterPartySignUp"
  },
  CounterPartySignUps: {
    component: CounterPartySignUp,
    path: "/inviteCounterParty"
  },
  TucklineSignup: {
    component: TrucklineSignup,
    path: "/TrucklineSignup"
  },
  SignupSuccess: {
    component: SignUpSuccess,
    path: "/signup/success"
  },
  Subscription: {
    component: Subscription,
    path: "/subscription"
  },
  CounterPartyBilling: {
    component: CounterPartyBilling,
    path: "/counterpartybilling"
  },
  CounterpartySubscription: {
    component: Subscription,
    path: "/verifyCounterParty"
  },
  ProceedSubscription: {
    component: ProceedSubscription,
    path: "/ProceedSubscription/:cost"
  },
  ForgotPassword: {
    component: ForgotPassword,
    path: "/forgot-password"
  },
  ResetPassword: {
    component: ResetPassword,
    path: "/ntrac/user/reset-password/:userId/:token"
  },
  Verification: {
    component: VerificationSuccess,
    path: "/subscribed"
  },
  Privacy: {
    component: Privacy,
    path: "/privacy"
  },
  TermsAndConditions: {
    component: TermsAndConditions,
    path: "/terms-and-conditions"
  }
};



// WEBPACK FOOTER //
// ./src/routes/publicRoutes.js